var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Modal", { attrs: { isOpen: _vm.isRequesting } }, [
    _c(
      "div",
      { attrs: { id: "loading-modal" } },
      [
        _c("EpSpinner", { staticClass: "icon" }),
        _c(
          "p",
          {
            staticClass: "title-loading",
            attrs: { "data-testid": "title-loading" }
          },
          [_vm._v(_vm._s(_vm.title))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }